import React from 'react'

import { Div, Link, Text } from '@vividseats/vivid-ui-kit'
import NextLink from 'next/link'

export interface LinkDetail {
    url: string
    label: string
    isExternal?: boolean
}

const LinkWidget: React.FC<{ title: string; links: LinkDetail[] }> = ({ title, links }) => {
    return (
        <Div data-testid="link-widget">
            <Div marginBottom={4}>
                <Text weight="bold" size="xl" altFont>
                    {title}
                </Text>
            </Div>
            <Text weight="regular-bold" altFont as="div">
                {links.map(({ url, label }, index) => (
                    <Div data-testid="widget-link" marginBottom={4} key={index}>
                        <Link
                            LinkComponent={NextLink}
                            align="left"
                            block
                            importance="text"
                            inherit
                            size="base"
                            muted
                            href={url}
                        >
                            {label}
                        </Link>
                    </Div>
                ))}
            </Text>
        </Div>
    )
}

export default LinkWidget
